import { createProvider } from '@frontend/store';
import { DEFAULT_SUBMISSIONS_DATE_FILTER, DEFAULT_SUBMISSIONS_SORT_ORDER } from '../../submission-list-view.constants';
import { SubmissionV2ListViewState, SubmissionV2ListViewStore } from './store.type';
import {
  SubmissionToggleUtils,
  SubmissionsInitUtils,
  SubmissionsFilterUtils,
  SubmissionListStateGetterUtils,
} from './utils';

const INITIAL_STATE: SubmissionV2ListViewState = {
  isSelectAllActive: false,
  isSelectAllIndeterminate: false,
  selectedSubmissions: [],
  selectedSubmissionIdsMap: {},
  canBatchSelectSubmissions: false,
  loadedSubmissions: [],
  disableSelection: false,
  submissionsSearchValue: '',
  dateFilterForSubmissions: DEFAULT_SUBMISSIONS_DATE_FILTER,
  sortOrderForSubmissions: DEFAULT_SUBMISSIONS_SORT_ORDER,
};

export const { useStore: useSubmissionV2ListViewStore, Provider: SubmissionV2ListViewStoreProvider } =
  createProvider<SubmissionV2ListViewStore>()((set, get) => ({
    ...INITIAL_STATE,

    toggleSelectionOfSubmission: (submission) => {
      set((state) => {
        return SubmissionToggleUtils.toggleSelectionOfSubmission({
          selectedSubmissions: state.selectedSubmissions,
          selectedSubmissionIdsMap: state.selectedSubmissionIdsMap,
          isSelectAllActive: state.isSelectAllActive,
          loadedSubmissions: state.loadedSubmissions,
          toggledSubmission: submission,
        });
      });
    },

    toggleSelectAll: () =>
      set((state) => {
        return SubmissionToggleUtils.toggleSelectAll({
          isSelectAllActive: state.isSelectAllActive,
          loadedSubmissions: state.loadedSubmissions,
          selectedSubmissions: state.selectedSubmissions,
        });
      }),

    resetSelection: () => set(() => SubmissionToggleUtils.resetSelection()),

    toggleBatchSelectionOfSubmissions: () =>
      set((state) => {
        return SubmissionToggleUtils.toggleBatchSelectionOfSubmissions({
          canBatchSelectSubmissions: state.canBatchSelectSubmissions,
        });
      }),

    getSubmissionSelectionStatus: () => {
      const {
        selectedSubmissions: selectedSubmissionIds,
        isSelectAllActive,
        loadedSubmissions: loadedSubmissionIds,
      } = get();
      return {
        selectedSubmissions: selectedSubmissionIds,
        isSelectAllActive,
        loadedSubmissions: loadedSubmissionIds,
      };
    },

    getSelectedSubmissions: () => {
      const {
        isSelectAllActive,
        loadedSubmissions: loadedSubmissionIds,
        selectedSubmissions: selectedSubmissionIds,
      } = get();
      return SubmissionListStateGetterUtils.getSelectedSubmissions({
        isSelectAllActive,
        loadedSubmissions: loadedSubmissionIds,
        selectedSubmissions: selectedSubmissionIds,
      });
    },

    setLoadedSubmissions: (submissions) =>
      set((state) => {
        return SubmissionsInitUtils.updateLoadedSubmissionIds({
          loadedSubmissions: submissions,
          selectedSubmissions: state.selectedSubmissions,
        });
      }),

    setDisableSelection: (disable) => set({ disableSelection: disable }),

    setSubmissionsSearchValue: (searchValue) =>
      set(
        SubmissionsFilterUtils.updateSearchValue({
          submissionsSearchValue: searchValue,
        })
      ),

    setSubmissionsFilter: (payload) => set(SubmissionsFilterUtils.updateSubmissionsFilter(payload)),
  }));
